import { z } from 'zod';

export const CompanyModel = z
  .object({
    training_assessment_completion_percent: z.number().int().optional(),
    is_parent: z.boolean().optional(),
  })
  .passthrough();

export type Company = z.infer<typeof CompanyModel>;
